import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClientInfoClientDetail, MerchantSetup, MerchantSetupAPI } from '../..';
import { mbeConfigService } from './mbe-config.service';
import { BasicResponse } from '@auth-suite-services/services';

@Injectable({
  providedIn: 'root',
})
export class MerchantSetupService {
  private URL;
  private AmassENSURL;
  private MBEngineURL;
  headers: HttpHeaders;

  private CXURL;
  CXheaders: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'PADM').url;
    this.AmassENSURL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'SDSETUP')
        .url;
    this.MBEngineURL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');

    this.CXURL = config.REST_SERVER_HOST + '/api/amassapp';
    this.CXheaders = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  // tslint:disable-next-line:max-line-length
  getAllMSE(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    gidFrom: number,
    gidTo: number,
    creationDate: string,
    relOSPIID: number,
    servicePointName: string
  ): Observable<MerchantSetupAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<MerchantSetupAPI>(
      `${this.URL}/mse/allmse/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}/${gidFrom ? gidFrom : 0}/${gidTo ? gidTo : 0}/${
        creationDate ? creationDate : '0'
      }/${relOSPIID ? relOSPIID : 0}/${
        servicePointName ? servicePointName : '0'
      }`,
      { headers }
    );
  }

  getMSE(id: number): Observable<MerchantSetup> {
    console.log('id:', id);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<MerchantSetup>(`${this.URL}/mse/getmse/${id}`, {
      headers,
    });
  }

  updateMSE(mse: MerchantSetup): Observable<BasicResponse> {
    const headers = this.headers;
    const updateMSE = JSON.stringify(mse);
    console.log('Update MSE: ', updateMSE);
    return this.httpClient.post<BasicResponse>(
      `${this.MBEngineURL}/mse/updatemse`,
      mse,
      { headers }
    );
  }
  // Changed                                        21/10/2024 RL
  SDupdateMSE(mse: any): Observable<BasicResponse> {
    const headers = this.headers;
    const updateMSE = JSON.stringify(mse);
    console.log('Update MSE: ', updateMSE);
    return this.httpClient.post<BasicResponse>(
      `${this.AmassENSURL}/mse/updatemse`,
      // `${this.URL}/mse/updatemse`,
      mse,
      { headers }
    );
  }

  CXupdateMSE(mse: MerchantSetup): Observable<BasicResponse> {
    const headers = this.headers;
    const updateMSE = JSON.stringify(mse);
    console.log('Update MSE: ', updateMSE);
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/mse/updatemse`,
      mse,
      { headers }
    );
  }

  loadCINCDE(RelOBACID: number): Observable<ClientInfoClientDetail> {
    const headers = this.headers;
    const JSONPayload = {
      RelOBACID,
    };
    console.log('RelOBACID: ', RelOBACID);
    return this.httpClient.post<ClientInfoClientDetail>(
      `${this.AmassENSURL}/cincde/getcincde`,
      JSONPayload,
      { headers }
    );
  }

  /**
   * Calls updateTINFromMerchant API. Body must be a plain object (uacId?, tinId?) or {}.
   * DoNotIntercept is sent via request options, not in the body.
   */
  OTPupdateMSE(
    id: number,
    body?: { uacId?: number; tinId?: string }
  ): Observable<BasicResponse> {
    const headers = this.CXheaders;
    const payload: { uacId?: number; tinId?: string } = {};
    if (body?.uacId != null) payload.uacId = body.uacId;
    if (body?.tinId != null) payload.tinId = body.tinId;
    return this.httpClient.post<BasicResponse>(
      `${this.CXURL}/ptr/updatetinfrommerchant/${id}`,
      payload,
      { headers }
    );
  }
}
